import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { INavLink, Nav } from '@fluentui/react';
import { IWithErrorHandlingProps } from './withErrorHandling';
import { OrbUserContext } from './OrbUserContext';
import { ThemeProvider } from '@fluentui/react/lib/Theme';
import { darkTheme } from '../AppGlobals';
import { DataContext } from './DataContext';
import { _onRenderNavLink } from './ZedXMainMenu';
import { LoggedUserInfoForMenu } from './LoggedUserInfoForMenu';

interface IStudyPlannerMenu extends IWithErrorHandlingProps {
    onLinkClicked?: () => void;
}

export const StudyPlannerMenu = ({ errorHandling: { clearErrors }, onLinkClicked }: IStudyPlannerMenu): React.ReactElement => {
    const { userContext, userPermissions: up, orbConfig } = useContext(OrbUserContext);
    const history = useHistory();
    const { pathname } = useLocation();
    const { dataServices } = useContext(DataContext);
    const [navs, setNavs] = useState([]);
    const resetErrors = useCallback(clearErrors, [clearErrors]);
    const [totalTasks, setTotalTasks] = useState(0);

    const fetchTotalTasks = () => {
        dataServices.app03TaskService.countTasksForStudyPlannerStudent(userContext.UserId).then(t => {
            setTotalTasks(t.filter(x => x.Archived !== true).length ?? 0);
        });
    };

    useEffect(() => {
        fetchTotalTasks();

        return () => {
            //console.log('Component Unmounted');
        };
    }, []);

    useEffect(() => {
        const routerNav = (path: string): void => {
            history.push(path);
            if (onLinkClicked) onLinkClicked();
        };

        const NamePathToNavLink = ({ name, path }): INavLink => {
            return { key: path, name: name, url: `#${path}`, onClick: () => routerNav(path) };
        };

        const links: INavLink[] = [
            { name: 'Home', path: '/' },
            { name: 'Welcome', path: '/a13/welcome' },
            { name: 'Insights', path: '/a13/insights' },
            { name: 'My Tasks', path: '/a13/tasks' },
        ].map(NamePathToNavLink);

        setNavs(links);
    }, [up, history, onLinkClicked, resetErrors]);

    return (
        <ThemeProvider theme={darkTheme}>
            <LoggedUserInfoForMenu />
            <Nav
                selectedKey={pathname}
                groups={[{ links: navs }]}
                onRenderLink={(lnk) => _onRenderNavLink(lnk, totalTasks)}
            />
        </ThemeProvider>
    );
};
